import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { SourcingInternalStoreComponent } from 'modules/sourcing-internal/stores/components/SourcingInternalStoreComponent';

export const AnalyseSourcingInternalCampaignSetupWithCandidateBatch: React.FC =
  () => {
    const { getPathParams } = usePathsV2();
    const { candidateBatchId, sessionId } =
      getPathParams.ANALYSE_SOURCE_INTERNAL_CAMPAIGN_SETUP_WITH_CANDIDATE_BATCH();

    return (
      <SourcingInternalStoreComponent
        sessionId={sessionId}
        initialCandidateBatchId={candidateBatchId}
      />
    );
  };
